module.exports = __webpack_public_path__ + "static/Yellow Card-905e72e07c77eec9a2c9d5a987b156ef.png";